import React, { useState } from "react";

import { quotePageURL, quotePageName, isRenewal } from "QuotePage/urls";
import { useLocation, useHistory } from "react-router-dom";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import { calendlyURL, calendlyRenewalsURL } from "ZeroRuby/urls";

import { TitleSmall } from "Cobalt/Header";
import { Modal, StandaloneTrigger, ModalBody, ModalHeader } from "Cobalt/Modal";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { Card } from "Common/Card/";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";

import RecommendationSurveyForm from "./recommendationSurveyCard/RecommendationSurveyForm";

import makeBem from "Utils/makeBem";

// TODO: this file requires refactoring to better handle employer application and quote page components

const bem = makeBem("RecommendationSurvey");
export const RecommendationSurveyStandaloneTrigger = (inputs) => (
  <StandaloneTrigger
    trigger={(props) => (
      <Button
        size="medium"
        color={inputs.customPlansSet || inputs.location == "plan_details_popover" ? "gray" : "blue"}
        onClick={(e) => {
          AnalyticsTracking.trackEvent("cta_clicked", {
            location: inputs.location,
            action: "take_recommendation_survey",
            custom_plans_set: inputs.customPlansSet,
          });

          props.onClick(e);
        }}
      >
        {inputs.customPlansSet ? "Change Survey Responses" : "Get Custom Recommendation"}
      </Button>
    )}
    modal={(props) => <RecommendationSurveyModal {...props} onSubmitModalCallback={inputs.onSubmitModalCallback} plan={inputs.plan} />}
  />
);

export const RecommendationSurveyCard = (props) => (
  <Card id="recommendation" mt={4} style={{ paddingTop: "24px", paddingBottom: "24px" }}>
    <Div className="flex-space-between" style={{ alignItems: "center" }}>
      <Div style={{ paddingRight: "64px" }}>
        <TitleSmall mt={0} mb={0}>
          {props.location == "plan_details_popover"
            ? "Need Help Choosing a Plan?"
            : props.customPlansSet
              ? "Want to revise or discuss these recommendations?"
              : "Prefer a Custom Recommendation?"}
        </TitleSmall>
        <BodyText>
          {props.customPlansSet
            ? "You can retake the survey or schedule a time with one of our licensed agents."
            : "We can help find plans whose coverage fit you and your employees' needs without unnecessary costs.  All you have to do is answer a few questions about your company."}
        </BodyText>
      </Div>
      <Div style={{ textAlign: "right" }}>
        <RecommendationSurveyStandaloneTrigger customPlansSet={props.customPlansSet} location={props.location} plan={props.plan} />

        {props.customPlansSet && (
          <Button
            color="link"
            p={0}
            mt={3}
            onClick={() => {
              window.Calendly.initPopupWidget({
                url: isRenewal() ? calendlyRenewalsURL() : calendlyURL(),
                prefill: {
                  name: props.contactName,
                  email: props.companyEmail,
                },
              });

              AnalyticsTracking.trackEvent("cta_clicked", {
                location: "recommendation_survey_card",
                feature: "recommendation_survey",
                type: "calendly_link_clicked",
                is_renewal: isRenewal(),
              });
            }}
          >
            <Icon icon="phone" pr={2} flavor="solid" />
            Book a 30 Minute Consultation
          </Button>
        )}
      </Div>
    </Div>
  </Card>
);

export const RecommendationSurveyModal = ({ onHide, show, onSubmitModalCallback }) => {
  const location = useLocation();
  const history = useHistory();
  const handleSubmitComplete = () => {
    AnalyticsTracking.trackEvent("survey_complete", {
      location: "recommendation_survey_modal",
    });

    // Need two different ways of handling navigation until quote page and
    // employer application are in the same app
    if (location.pathname.includes("small-group")) {
      history.push(quotePageName());
    } else {
      window.location.href = quotePageURL();
    }
    onHide();
  };

  const handleBackOutOfForm = () => {
    AnalyticsTracking.trackEvent("modal_closed", {
      location: "recommendation_survey_modal",
      action: "clicked_back_button",
    });

    onHide();
  };

  const [currentPage, _setCurrentPage] = useState(0);

  return (
    <Modal show={show} onHide={onHide} backdropClassName={bem("backdrop")}>
      <ModalHeader closeButton>
        <TitleSmall mt={0} mb={0}>
          Get Custom Recommendation
        </TitleSmall>
      </ModalHeader>
      <ModalBody>
        <RecommendationSurveyForm
          onSubmitComplete={handleSubmitComplete}
          onBackOutOfForm={handleBackOutOfForm}
          onSubmitModalCallback={onSubmitModalCallback}
          currentPage={currentPage}
        />
      </ModalBody>
    </Modal>
  );
};
